import React, { useState } from 'react'
import { styled, Box } from '@mui/material'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(() => ({
    border: `none`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&::before': {
      display: 'none',
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }:any) => ({
  padding: theme.spacing(2)
}))

const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none"
        },
        ".expandIconWrapper": {
          display: "none"
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block"
        }
      }}
    >
      <div className="expandIconWrapper">-</div>
      <div className="collapsIconWrapper">+</div>
    </Box>
  )
}

const FAQOwnerItemComponent = () => {
  const [expanded, setExpanded] = useState<string | false>('panel1')

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false)
    }

  return (
    <>
      <div>
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>How much does it cost to list my EQUIPMENT?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            No, listing an EQUIPMENT is absolutely free with Haystackers.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>How much commission does Haystackers charge?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Haystackers offers greater service at a lower price. We understand that most of the work is performed by owners, and we want to put maximum money in to your pockets. Hence, we feel 15% commissions is reasonable. This is applied on Base Rent, Add On fees, excess usage and other checkout fees claimed by owner.
            </Typography>
          </AccordionDetails>
        </Accordion>
        
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary aria-controls="panel3d-content" id="panel3d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>What are the pre-requisites to list an EQUIPMENT?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            EQUIPMENT should be in good condition and pass the self-inspection on quarterly basis.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary aria-controls="panel4d-content" id="panel4d-header" expandIcon={<CustomExpandIcon />}>
            <Typography>How do I list my EQUIPMENT?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Listing an EQUIPMENT is very simple. After you sign up, you can list your EQUIPMENT on the owner dashboard either using our Website or by using our App. You will need to describe your EQUIPMENT like make, model & year. Upload some pictures of your EQUIPMENT as pictures are the first impression of your EQUIPMENT and it’s better to be perfect. That’s it. It’s that simple. When someone request to rent your EQUIPMENT, you will be notified.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary aria-controls="panel5d-content" id="panel5d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>What are Instabooking and Manual Booking?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Instabooking is a convenient approach that allows renters to book EQUIPMENT and get confirmation immediately. And Manual booking gives you an opportunity to connect with your renter personally and understand their usage and requirements. Also rental requests need to be personally approved by you in the owner dashboard. I am not sure whether to have instabooking or manual? If you plan to interact and understand your renter then you can opt for Manual approval. If you are too busy to coordinate then you can opt for Instabook option.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
        >
          <AccordionSummary aria-controls="panel6d-content" id="panel6d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>Where can I see the breakup of payment?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            In the owner dashboard click Payments and each payment made will have detailed breakdown.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel7'}
          onChange={handleChange('panel7')}
        >
          <AccordionSummary aria-controls="panel7d-content" id="panel7d-header" expandIcon={<CustomExpandIcon />}>
          <Typography>What is 90 day inspection requirement?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            In the best interest of the owner, renter and the EQUIPMENT we recommend a periodic quarterly inspection check on all amenities, mechanicals, tires of the EQUIPMENT. The inspection report has to be retained with the owner and must be provided in case of any insurance claims.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}

export default FAQOwnerItemComponent
